import {Injectable} from '@angular/core';
import {BaseService} from '../core/service/base.service';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {PurchaseProcess, PurchaseProcessLine} from '../model/purchase-process';
import {Observable} from 'rxjs';
import {HeaderConstants} from '../core/utils/headers.constants';

@Injectable()
export class PurchaseProcessLineService extends BaseService<PurchaseProcessLine> {

  serviceUrl(): string {
    return `/api/t/{tenant}/purchase-process-lines`;
  }

  constructor(protected http: HttpClient) {
    super(http);
  }

  getAll(refresh = true): Observable<PurchaseProcess[]> {
    const paramsData = new HttpParams();
    const options = {params: paramsData, headers: new HttpHeaders().set(HeaderConstants.CACHED, refresh ? 'false' : 'true')};
    return this.http
      .get<PurchaseProcess[]>(`${this.serviceUrl()}/not-fully-assigned`, options );
  }

}
